var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 2C16.2 2 18 3.79 18 6L18 14C18 16.2 16.2 18 14 18L6 18C3.79 18 2 16.2 2 14L2 6C2 3.79 3.79 2 6 2L14 2ZM11 7C12.1 7 13 7.89 13 9L13 11C13 12.1 12.1 13 11 13L9 13C7.89 13 7 12.1 7 11L7 9C7 7.89 7.89 7 9 7L11 7ZM8 2L8 0M12 2L12 0M12 18L12 20M8 18L8 20M18 8L20 8M18 12L20 12M2 8L0 8M2 12L0 ",
    stroke: "#0478FE",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.7335b80ac6930da6be0580974d41e3ab.svg";
export { ForwardRef as ReactComponent };